import React, { useMemo } from 'react';
import { OChartBase, withChartTheme } from './OChartBase';
import { ECHARTS_COLOR_PALETTE } from '../Hooks/useColorArrayHooks';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';

echarts.use([PieChart]);

/**
 * ODonutChart - standardized donut chart with theme and safe defaults
 * Deep-merges series[0] for data and name to avoid dropping pie config.
 */
const ODonutChart = ({ options, minHeight, maxHeight, style, theme }) => {
	const merged = useMemo(() => {
		const baseOptions = {
			color: ECHARTS_COLOR_PALETTE,
			tooltip: { trigger: 'item' },
			legend: { type: 'scroll', bottom: 10 },
			series: [
				{
					type: 'pie',
					radius: ['40%', '70%'],
					avoidLabelOverlap: true,
					label: { show: false, position: 'center' },
					labelLine: { show: false },
					data: [],
				},
			],
		};

		// Avoid replacing the entire series array; merge into series[0]
		const incomingSeries = options?.series?.[0] || {};
		const normalized = {
			...options,
			legend: { bottom: 10, type: 'scroll', ...(options?.legend || {}) },
			series: [
				{
					...baseOptions.series[0],
					...incomingSeries,
					data:
						incomingSeries.data ||
						options?.data ||
						baseOptions.series[0].data,
				},
			],
		};

		return withChartTheme({ ...baseOptions, ...normalized }, theme);
	}, [options, theme]);

	return (
		<OChartBase
			options={merged}
			minHeight={minHeight}
			maxHeight={maxHeight}
			style={style}
		/>
	);
};

export default ODonutChart;
